import request from '../../utils/request';
import { Result } from '@/models/general';
import {
  TournamentView,
  TournamentListView,
  TournamentStatsView,
  TournamentListQuery,
  CreateTournamentInput,
  UpdateTournamentInput,
  StandingEntry,
  BracketView,
  GenerateBracketInput,
} from '@/models/tournament';

export async function getTournaments(query: TournamentListQuery) {
  const response = await request.get<Result<TournamentListView>>('Tournament/GetTournaments', { params: query });
  return response.data;
}

export async function getTournament(id: number) {
  const response = await request.get<Result<TournamentView>>(`Tournament/GetTournament/${id}`);
  return response.data;
}

export async function createTournament(input: CreateTournamentInput) {
  const response = await request.post<Result<TournamentView>>('Tournament/CreateTournament', input);
  return response.data;
}

export async function updateTournament(input: UpdateTournamentInput) {
  const response = await request.put<Result<TournamentView>>('Tournament/UpdateTournament', input);
  return response.data;
}

export async function archiveTournament(id: number) {
  const response = await request.post<Result<boolean>>(`Tournament/ArchiveTournament/${id}`);
  return response.data;
}

export async function getTournamentStats() {
  const response = await request.get<Result<TournamentStatsView>>('Tournament/GetTournamentStats');
  return response.data;
}

export async function getStandings(tournamentId: number) {
  const response = await request.get<Result<StandingEntry[]>>(`Tournament/GetStandings/${tournamentId}`);
  return response.data;
}

export async function getBracket(tournamentId: number) {
  const response = await request.get<Result<BracketView>>(`Tournament/GetBracket/${tournamentId}`);
  return response.data;
}

export async function generateBracket(tournamentId: number, input: GenerateBracketInput) {
  const response = await request.post<Result<BracketView>>(`Tournament/GenerateBracket/${tournamentId}`, input);
  return response.data;
}
